import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox", "innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: _ctx.props.width,
    height: _ctx.props.height,
    viewBox: _ctx.icon.viewBox,
    innerHTML: _ctx.icon.content
  }, null, 8, _hoisted_1))
}